import { createAsyncAction } from 'typesafe-actions';
import { NotificationRule } from '@rootCommon/types/site';
import { IdType } from '@rootCommon/types/common';

export const fetchNotificationRules = createAsyncAction(
  'FETCH_NOTIFICATION_RULES_REQUEST',
  'FETCH_NOTIFICATION_RULES_SUCCESS',
  'FETCH_NOTIFICATION_RULES_FAILURE',
)<IdType, NotificationRule[], Error>();

export const updateNotificationRules = createAsyncAction(
  'UPDATE_NOTIFICATION_RULES_REQUEST',
  'UPDATE_NOTIFICATION_RULES_SUCCESS',
  'UPDATE_NOTIFICATION_RULES_FAILURE',
)<{ siteId: IdType; data: NotificationRule[] }, NotificationRule[], Error>();
